// @ts-nocheck
export const planTitles = [
  {
    tag: 'FREE_PLAN',
    order: 0,
    title: 'Cursos libres',
    isHighlighted: false,
  },
  {
    tag: 'PREMIUM',
    order: 1,
    title: 'Plan Individual',
    isHighlighted: false,
  },
  {
    tag: 'PREMIUM_DUO',
    order: 2,
    title: 'Plan Dúo',
    isHighlighted: false,
  },
  {
    tag: 'FAMILIAR',
    order: 3,
    title: 'Plan Familiar',
    isHighlighted: false,
  },
];

export const benefits = [
  {
    title: 'Acceso a todos los cursos',
    description:
      'Tendrás disponible +500 cursos en 12 categorías diferentes. No incluye MidroDegrees.',
    FREE_PLAN: {
      planName: 'Cursos',
      isHighlighted: false,
      order: 1,
      hasAccess: false,
    },
    PREMIUM: {
      planName: 'Individual',
      isHighlighted: false,
      order: 1,
      hasAccess: true,
    },
    PREMIUM_DUO: {
      planName: 'Dúo',
      isHighlighted: false,
      order: 2,
      hasAccess: true,
    },
    FAMILIAR: {
      planName: 'Familiar',
      isHighlighted: false,
      order: 3,
      hasAccess: true,
    },
  },
  {
    title: 'Estreno de cursos cada semana',
    description:
      'Estarás en la primera fila para los lanzamientos de cursos de cada semana, ¡agéndalo! ',
    FREE_PLAN: {
      planName: 'Cursos',
      isHighlighted: false,
      order: 1,
      tag: 'FREE',
      hasAccess: false,
    },
    PREMIUM: {
      planName: 'Individual',
      isHighlighted: false,
      order: 1,
      hasAccess: true,
    },
    PREMIUM_DUO: {
      planName: 'Dúo',
      isHighlighted: false,
      order: 2,
      hasAccess: true,
    },
    FAMILIAR: {
      planName: 'Familiar',
      isHighlighted: false,
      order: 3,
      hasAccess: true,
    },
  },
  {
    title: 'Especializaciones online exclusivas',
    description:
      'Accede a rutas de aprendizaje cortas en los temas de mayor demanda en la actualidad.',
    FREE_PLAN: {
      planName: 'Cursos',
      isHighlighted: false,
      order: 1,
      tag: 'FREE',
      hasAccess: false,
    },
    PREMIUM: {
      planName: 'Individual',
      isHighlighted: false,
      order: 1,
      hasAccess: true,
    },
    PREMIUM_DUO: {
      planName: 'Dúo',
      isHighlighted: false,
      order: 2,
      hasAccess: true,
    },
    FAMILIAR: {
      planName: 'Familiar',
      isHighlighted: false,
      order: 3,
      hasAccess: true,
    },
  },
  {
    title: 'Servicio de mentoría',
    description:
      'Resuelve tus dudas y obtén feedback de tus proyectos comunicándote directamente con mentores expertos.',
    FREE_PLAN: {
      planName: 'Cursos',
      isHighlighted: false,
      order: 1,
      tag: 'FREE',
      hasAccess: false,
    },
    PREMIUM: {
      planName: 'Individual',
      isHighlighted: false,
      order: 1,
      hasAccess: true,
    },
    PREMIUM_DUO: {
      planName: 'Dúo',
      isHighlighted: false,
      order: 2,
      hasAccess: true,
    },
    FAMILIAR: {
      planName: 'Familiar',
      isHighlighted: false,
      order: 3,
      hasAccess: true,
    },
  },
  {
    title: 'Diplomas digitales',
    description:
      'Certifica lo que aprendes y potencia tu CV con un diploma por curso o especialización.',
    FREE_PLAN: {
      planName: 'Cursos',
      isHighlighted: false,
      order: 1,
      tag: 'FREE',
      hasAccess: false,
    },
    PREMIUM: {
      planName: 'Individual',
      isHighlighted: false,
      order: 1,
      hasAccess: true,
    },
    PREMIUM_DUO: {
      planName: 'Dúo',
      isHighlighted: false,
      order: 2,
      hasAccess: true,
    },
    FAMILIAR: {
      planName: 'Familiar',
      isHighlighted: false,
      order: 3,
      hasAccess: true,
    },
  },
  {
    title: 'Lives exclusivos todas las semanas',
    description:
      'Interactúa con tus profesores y mentores en sesiones en vivo que refuercen tu aprendizaje.',
    FREE_PLAN: {
      planName: 'Cursos',
      isHighlighted: false,
      order: 1,
      tag: 'FREE',
      hasAccess: false,
    },
    PREMIUM: {
      planName: 'Individual',
      isHighlighted: false,
      order: 1,
      hasAccess: true,
    },
    PREMIUM_DUO: {
      planName: 'Dúo',
      isHighlighted: false,
      order: 2,
      hasAccess: true,
    },
    FAMILIAR: {
      planName: 'Familiar',
      isHighlighted: false,
      order: 3,
      hasAccess: true,
    },
  },
  {
    title: 'Estudio de TOP cases de empresas globales',
    description:
      'Accede a una sección exclusiva del blog donde aprenderás las buenas prácticas de las empresas más reconocidas.',
    FREE_PLAN: {
      planName: 'Cursos',
      isHighlighted: false,
      order: 1,
      tag: 'FREE',
      hasAccess: false,
    },
    PREMIUM: {
      planName: 'Individual',
      isHighlighted: false,
      order: 1,
      hasAccess: true,
    },
    PREMIUM_DUO: {
      planName: 'Dúo',
      isHighlighted: false,
      order: 2,
      hasAccess: true,
    },
    FAMILIAR: {
      planName: 'Familiar',
      isHighlighted: false,
      order: 3,
      hasAccess: true,
    },
  },
  {
    title: 'Accesos para múltiples usuarios',
    description:
      'Comparte la cuenta entre 2 personas (Plan Dúo) o de 3 a 4 personas (Plan Familiar) ¡con todos los beneficios!',
    FREE_PLAN: {
      planName: 'Cursos',
      isHighlighted: false,
      order: 1,
      tag: 'FREE',
      hasAccess: false,
    },
    PREMIUM: {
      planName: 'Individual',
      isHighlighted: false,
      order: 1,
      hasAccess: true,
    },
    PREMIUM_DUO: {
      planName: 'Dúo',
      isHighlighted: false,
      order: 2,
      hasAccess: 'Hasta 2 personas',
    },
    FAMILIAR: {
      planName: 'Familiar',
      isHighlighted: false,
      order: 3,
      hasAccess: 'Hasta 4 personas',
    },
  },
  {
    title: 'Asesoría académica',
    description:
      'Mantén constante contacto con nuestro equipo educativo para crear tu plan de estudios y alcanzar tus objetivos.',
    FREE_PLAN: {
      planName: 'Cursos',
      isHighlighted: false,
      order: 1,
      tag: 'FREE',
      hasAccess: false,
    },
    PREMIUM: {
      planName: 'Individual',
      isHighlighted: false,
      order: 1,
      hasAccess: true,
    },
    PREMIUM_DUO: {
      planName: 'Dúo',
      isHighlighted: false,
      order: 2,
      hasAccess: true,
    },
    FAMILIAR: {
      planName: 'Familiar',
      isHighlighted: false,
      order: 3,
      hasAccess: true,
    },
  },
  {
    title: 'Soporte personalizado por chat',
    description:
      'Resuelve tus dudas o problemas con la plataforma con un chat privado con el equipo de atención.',
    FREE_PLAN: {
      planName: 'Cursos',
      isHighlighted: false,
      order: 1,
      tag: 'FREE',
      hasAccess: false,
    },
    PREMIUM: {
      planName: 'Individual',
      isHighlighted: false,
      order: 1,
      hasAccess: true,
    },
    PREMIUM_DUO: {
      planName: 'Dúo',
      isHighlighted: false,
      order: 2,
      hasAccess: true,
    },
    FAMILIAR: {
      planName: 'Familiar',
      isHighlighted: false,
      order: 3,
      hasAccess: true,
    },
  },
  {
    title: 'Soporte exclusivo por llamadas',
    description:
      'Programa llamadas con nuestro team de Customer Happiness según horarios de disponibilidad.',
    FREE_PLAN: {
      planName: 'Cursos',
      isHighlighted: false,
      order: 1,
      tag: 'FREE',
      hasAccess: false,
    },
    PREMIUM: {
      planName: 'Individual',
      isHighlighted: false,
      order: 1,
      hasAccess: true,
    },
    PREMIUM_DUO: {
      planName: 'Dúo',
      isHighlighted: false,
      order: 2,
      hasAccess: true,
    },
    FAMILIAR: {
      planName: 'Familiar',
      isHighlighted: false,
      order: 3,
      hasAccess: true,
    },
  },
];
